import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { ResearchPanel } from "@/components/ResearchPanel";
import { Stethoscope, ShieldAlert } from "lucide-react";

export default function AIResearch() {
  const [dogs, setDogs] = useState([]);
  const params = new URLSearchParams(useLocation().search);
  const preDog = params.get("dog") || "";
  const preQuery = params.get("q") || "";

  useEffect(() => { api.get("/dogs").then((r) => setDogs(r.data)); }, []);

  return (
    <div data-testid="research-page">
      <div className="flex items-center gap-3 mb-2">
        <div className="h-11 w-11 rounded-2xl bg-accent/20 flex items-center justify-center"><Stethoscope className="h-6 w-6 text-accent-foreground" /></div>
        <h1 className="font-head text-4xl font-extrabold tracking-tight">AI Vet Research</h1>
      </div>
      <p className="text-muted-foreground mb-4 max-w-2xl">Input your dog's symptoms and let AI scan veterinary sources, publications and owner forums for possible causes and next steps.</p>

      <div className="flex items-start gap-2 rounded-xl bg-secondary/10 border border-secondary/30 px-4 py-3 mb-6 text-sm">
        <ShieldAlert className="h-4 w-4 text-secondary shrink-0 mt-0.5" />
        <p><b>Informational only.</b> AI research is not a diagnosis and is not a substitute for a licensed veterinarian. For emergencies, contact your vet immediately.</p>
      </div>

      <ResearchPanel
        kind="health"
        dogs={dogs}
        defaultDog={preDog}
        defaultQuery={preQuery}
        placeholder={{ label: "Describe the symptoms", text: "e.g. Scratching ears constantly, head shaking, red inner ear for 3 days..." }}
        extraLabel="Recent changes / context (optional)"
        extraPlaceholder="New food, environment change, age, existing conditions..."
      />
    </div>
  );
}
